// extracted by mini-css-extract-plugin
export default {"subMenu":"ZyigyZ","container":"n_SxIP","bigDropdownWrapper":"Gnitu4","background":"f9ZAo_","fadeIn":"ziS_dS","expand":"IkbbmL","mobileSeparator":"kQJnUN"};